export default () => ({
    '& .tags-dropdown': {
        display: 'none',
    },
});
